
export const resumenVentasLang = {
    TituloCliente: {
        es: 'RESUMEN DE VENTAS POR CLIENTE',
        en: 'SALES SUMMARY BY CUSTOMER'
    },
    TituloAgente: {
        es: 'RESUMEN DE VENTAS POR AGENTE',
        en: 'SALES SUMMARY BY AGENT'
    },
    TituloSegunAgente: {
        es: 'RESUMEN DE VENTAS POR AGENTE',
        en: 'SALES SUMMARY BY AGENT'
    },
    TituloVentasAnualPorAgente: {
        es: 'VENTAS ANUALES POR AGENTE',
        en: 'ANNUAL SALES BY AGENT'
    },
    TituloVentasAnualPorCliente: {
        es: 'VENTAS ANUALES POR CLIENTE',
        en: 'ANNUAL SALES BY CUSTOMER'
    },

}